import { v4 as uuidv4 } from 'uuid';
import { db } from './firebase'
import { setDoc, getDoc, doc, onSnapshot } from "firebase/firestore";
import { Debug } from '../debugger';

// loads a project with an id and returns the data in a callback
export const loadProject = async (projectId, callback) => {
    Debug("projectServices", "loading project ...")
	const docRef = doc(db, "projects", projectId);
	const docSnap = await getDoc(docRef);
	if (docSnap.exists()) {
        Debug("projectServices", "loaded", projectId)
		callback(docSnap.data())
	} else {
        Debug("projectServices", "project not found", projectId)
		callback(null)
	}
}

// saves data to a project with the given id. overwrites if exists!
export const saveProject = async (projectId, data) => {
    Debug("projectServices", "saving project ...")
	const docRef = doc(db, "projects", projectId)
	await setDoc(docRef, data);
    Debug("projectServices", "saved")
}

// saves the data to a new project id and updates the URL accordingly. callsback with the new projectid
export const duplicateProject = (data, callback) => {
    Debug("projectServices", "duplicating project ...")
	const projectId = uuidv4()
	saveProject(projectId, data)
	window.history.replaceState(null, null, "?project_id=" + projectId);
    callback(projectId)
    Debug("projectServices", "duplicated")
}

var viewerDidConnectToProjectWithId = null

const timestamp = () => {
    return Math.floor(Date.now() / 1000)
}

// sends a heartbeat so the editor knows the viewer is connected
const heartBeatInterval = setInterval(async () => {
    if (viewerDidConnectToProjectWithId === null) { return }
    const docRef = doc(db, "viewers", viewerDidConnectToProjectWithId)
    await setDoc(docRef, {"heartbeat": timestamp()});
    Debug("projectServices", "setting viewer did connect ...")
}, 1000)

// tells the host that the viewer connected
export const setViewerConnected = async (projectId) => {
    viewerDidConnectToProjectWithId = projectId
    window.addEventListener('beforeunload', async (e) => {
        clearInterval(heartBeatInterval)
        const docRef = doc(db, "viewers", viewerDidConnectToProjectWithId)
        await setDoc(docRef, {"heartbeat": 0});
        e.preventDefault();
        e.returnValue = '';
        Debug("projectServices", "setting viewer did disconnect ...")
    });
}


let shouldListenForViewersOfProjectWithId = null
let lastHeartbeatTime = 0
let viewerCallback = () => {}

var didSetListenForViewerInterval = false

// executes the callback with true if a viewer is connected, or false if it isn't
export const listenForViewers = (projectId, callback) => {
    shouldListenForViewersOfProjectWithId = projectId
	const docRef = doc(db, "viewers", projectId)
	const unsub = onSnapshot(docRef, (doc) => {
    	const data = doc.data()
        if (data !== undefined) {
            if ("heartbeat" in data) {
                lastHeartbeatTime = data.heartbeat ?? 0
            }
        }
        viewerCallback = callback
	});

    if (!didSetListenForViewerInterval) {
        didSetListenForViewerInterval = true
        // listens for heartbeat so the editor knows the viewer is connected
        setInterval(async () => {
            if (shouldListenForViewersOfProjectWithId === null) { return }
            const ts = timestamp()
            const offset = Math.abs(lastHeartbeatTime - ts)
            const isConnected = offset < 5
            viewerCallback(isConnected)
        }, 1000)
    }
}

